/**
 * CareLogix™ ORACLE — AdminOne AI Business Command (Phase 43).
 * Operator-only wrapper that reuses the member surface with elevated context.
 */
import React from "react";
import OracleAIBusinessPage from "@/pages/oracle/OracleAIBusinessPage";
import { ExternalDeliveryApprovalPanel } from "@/components/adminone/ExternalDeliveryApprovalPanel";
import { ApprovalExpiryReattestationPanel } from "@/components/adminone/ApprovalExpiryReattestationPanel";

export default function AdminOneAIBusinessCommandPage() {
  return (
    <div data-testid="adminone-ai-business-command-page">
      <OracleAIBusinessPage />
      <ExternalDeliveryApprovalPanel />
      <ApprovalExpiryReattestationPanel />
    </div>
  );
}
